//Case specific, works only for product finder
define('modules/svgToImage',["jquery", "app"], function($, App) {
    function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;

        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    var fontfamily = '';
    function addFonts(cb) {
        if(fontfamily) {
            cb(fontfamily);
            return;
        }

        var fontText = "@font-face {font-family: 'Raleway';font-style: normal;font-weight: 400;src: local('Raleway'), local('Raleway-Regular'), url(https://fonts.gstatic.com/s/raleway/v11/0dTEPzkLWceF7z0koJaX1A.woff2) format('woff2');unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;}";
        var fontUrlRegexp = /url\(["']?(.+?)["']?\)/;
        var fontUrlMatch = fontText.match(fontUrlRegexp)[1];
        var oReq = new XMLHttpRequest();
        oReq.addEventListener('load', fontLoaded);
        oReq.open('GET', fontUrlMatch);
        oReq.responseType = 'arraybuffer';
        oReq.send();

        function fontLoaded() {
            var fontBits = oReq.response;
            updateFontStyle(arrayBufferToBase64(fontBits));
        }

        function updateFontStyle(fontInBase64) {
            var dataUrl = 'url("data:font/woff2;base64,' + fontInBase64 + '")';
            fontfamily = fontText.replace(fontUrlRegexp, dataUrl);
            cb(fontfamily);
        }
    }

    function prepareSvg(el, options, cb) {
        options = options || {};
        options.scale = options.scale || 1;

        var width, height;
        width = options.width;
        height = options.height;
        el.setAttribute("width", width * options.scale);
        el.setAttribute("height", height * options.scale);
        el.setAttribute("viewBox", [0, 0, width, height].join(" "));

        //Add styles to inline
        addFonts(function(css) {
            //Don't touch this line, this will be filled from gulpfile
            css += /*MapCSS*/".rack {  cursor: pointer;  fill: #2C363F;  stroke: #96939B;  stroke-width: 0.5; } .rack.wall, .rack.blocked {    fill: #96939B;    stroke: #96939B; } .rackname {  fill: #FFF8F0;  font-family: 'Lato', 'Raleway'; }"/*MapCSS*/;

            var s = document.createElement('style');
            s.setAttribute('type', 'text/css');
            s.innerHTML = css;
            var defs = el.querySelectorAll('defs')[0];
            defs.insertBefore(s, defs.firstChild);
            if (cb) {
                cb(el, width, height);
            }
        });
    }

    function toUrl(el, options, cb) {
        prepareSvg(el, options, function(svg) {
            var svgString = new XMLSerializer().serializeToString(svg);
            if (cb) {
                cb('data:image/svg+xml;base64,'+ btoa(unescape(encodeURIComponent(svgString))));
            }
        });
    }

    return {
        toDataURI : function(el, options, cb) {
            options = options || {};
            options.encoderType = options.encoderType || 'image/png';
            options.encoderOptions = options.encoderOptions || 0.8;

            var convertToPng = function(src, w, h) {
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                canvas.width = w;
                canvas.height = h;

                context.drawImage(src, 0, 0);
                cb(canvas.toDataURL(options.encoderType, options.encoderOptions));
            };

            toUrl(el, options, function(uri) {
                var image = new Image();

                image.onload = function() {
                    convertToPng(image, image.width, image.height);
                };

                image.onerror = function() {
                    console.error('There was an error loading the data URI as an image\n');
                };

                image.src = uri;
            });
        }
    };
});
